import { expose } from 'threads/worker';
import { processProjectEnvironmentTypePermissions, processProjectPermissions } from './permission-worker-logic';

const permissionWorker = { processProjectPermissions, processProjectEnvironmentTypePermissions };

export type PermissionWorker = typeof permissionWorker;

expose(permissionWorker);
